/* eslint-disable */
export const sb = {
    'inPlay': 'In-Play',
    'liveStream': 'Live Stream',
    'azCompetitions': 'A-Z Competitions',
    'liveSIM': 'PRE-PARADE',
    'allSports': 'All Sports',
    'azSports': 'A-Z Sports',
    'AZSports': 'A-Z Menu',
    'delay': '(Possible delay: 10 seconds)',
    'logged': 'You have been logged in:',
    'topGames': 'Top Games',
    'topSports': 'Top Sports',
    'players': 'Players',
    '1st': '1st',
    'anytime': 'Anytime',
    '2more': '2 or More',
    'last': 'Last',
    'Tie': 'TIE',
    'hatrick': 'Hatrick',
    'AZ': 'A-Z',
    'bold': 'Bold:',
    'priced': 'Priced',
    'wasPrice': 'Was',
    'nowPrice': 'Now',
    'showAllLiveStreamingEvents': 'Show All Live Streaming Events',
    'hideAllLiveStreamingEvents': 'Show Less Live Streaming Events',
    'gambling': 'Responsible Gambling',
    'contacts': 'Contact Us',
    'lobby': 'Sports',
    'ok': 'Ok',
    'selectYourCoupon': 'Select your Coupon',

    'tabsNameJackpot': 'Jackpot',
    'football': 'Football',
    'americanfootball': 'American Football',
    'boxing': 'Boxing',
    'golf': 'Golf',
    'cricket': 'Cricket',
    'horseracing': 'Horse Racing',
    'greyhound': 'Greyhounds',
    'snooker': 'Snooker',
    'pool': 'Pool',
    'motorsports': 'Motor Sports',
    'motorbikes': 'Motor Bikes',
    'speedway': 'Speedway',
    'hurling': 'Hurling',
    'tennis': 'Tennis',
    'darts': 'Darts',
    'rugbyunion': 'Rugby Union',
    'rugbyleague': 'Rugby League',
    'aussierules': 'Aussie Rules',
    'bowls': 'Bowls',
    'hockey': 'Hockey',
    'volleyball': 'Volleyball',
    'beachvolleyball': 'Beach Volleyball',
    'badminton': 'Badminton',
    'basketball': 'Basketball',
    'icehockey': 'Ice Hockey',
    'formula1': 'Formula 1',
    'baseball': 'Baseball',
    'tvspecials': 'TV Specials',
    'politics': 'Politics',
    'handball': 'Handball',
    'ufcmma': 'UFC/MMA',
    'cycling': 'Cycling',
    'movies': 'Movies',
    'gaelicfootball': 'Gaelic Football',
    'esports': 'E-sports',
    'tabletennis': 'Table Tennis',

    'tomorrow': 'Tomorrow',
    'today': 'Today',
    'yesterday': 'Yesterday',
    'more': 'More',
    'cancel': 'Cancel',
    'accept': 'Accept',
    'distance': 'Distance:',
    'winOrEachWay': 'Win or E/W',
    'bettingWithout': 'Betting W/O',
    'otherMarkets': 'More Markets',
    'toFinishMarkets': 'To Finish',
    'topFinishMarkets': 'Top Finish',
    'insuranceMarkets': 'Place Insurance',
    'tricast': 'Tricast',
    'forecast': 'Forecast',

    'extraPlaceTitle': 'Extra Place Offer',

    'byLeaguesCompetitions': 'Leagues & Competitions',
    'byLeaguesCups': 'By Leagues & Cups',
    'byCompetitions': 'By Competitions',
    'byLatestResults': 'By Latest Results',
    'byMeeting': 'By Meeting',
    'byMeetings': 'By Meetings',
    'byTime': 'By Time',
    'noCouponsFound': 'No coupons found',
    'noEventsFound': 'There are currently no events available',
    'noLiveEventsFound': 'There are currently no Live events available',
    'noUpcomingEventsAvailable': 'There are no upcoming events',
    'streamIsNotAvailable': 'The Stream for this event is currently not available.',
    'noUpcomingEventsFound': 'There are no upcoming events',
    'stream': 'Stream',
    'viewFullRace': 'View Full Race Card',
    'previousRaces': 'Previous',
    'nextRaces': 'Next',
    'previousCard': 'Previous',
    'nextCard': 'Next',
    'viewAll': 'View All',
    'seeAll': 'See All',
    'seeMore': 'See More',
    'seeLess': 'See Less',
    'events': 'Events',
    'showAll': 'Show All',
    'terms': 'Terms',
    'live': 'Live',
    'byLiveNow': 'Live Now',
    'byUpcoming': 'Upcoming',
    'byRaces': 'By Races',
    'player': 'player',
    'number': 'number',
    'odds': 'odds',

    'form': 'Form: ',
    'formHeader': 'Form',
    'card': 'Card',
    'jockeyTrainer': 'Jockey/Trainer',
    'rpRating': 'R.P Rating',
    'previousOdds': 'Previous\nOdds',
    'currentOdds': 'Current\nOdds',
    'details': 'Details',
    'rDetails': 'Runner Details',
    'horse': 'Horse',
    'dog': 'Dog',
    'jockey': 'Jockey',
    'trainer': 'Trainer',
    'formGuide': 'Form',
    'age': 'Age',
    'weight': 'Weight',
    'stallNo': 'Stall No',
    'rating': 'Rating',
    'runner': 'Runner',
    'sire': 'Sire',

    'flagUK': 'UK & IRE',
    'flagUkLong': 'UK / IRELAND RACES',
    'flagUS': 'USA',
    'flagUSLong': 'USA Races',
    'flagZA': 'South Africa',
    'flagZALong': 'South Africa Races',
    'flagAE': 'UAE',
    'flagAELong': 'UAE Races',
    'flagCL': 'Chile',
    'flagCLLong': 'Chile Races',
    'flagIN': 'India',
    'flagINLong': 'India Races',
    'flagAU': 'Australia',
    'flagAULong': 'Australia Races',
    'flagFR': 'France',
    'flagFRLong': 'France Races',
    'flagINT': 'Other International',
    'flagINTLong': 'International Races',
    'flagVR': 'Virtual',
    'flagVRaces': 'Coral Legends',
    'flagALL': 'All Races',
    'flagENHRCS': 'Offers and Featured Races',

    'tabsNameFeatured': 'Featured',
    'tabsNameAntepost': 'Future',
    'tabsNameSpecials': 'Specials',
    'tabsNameYourcall': 'Yourcall',

    'tabsNameLive': 'Live',
    'tabsNameInPlay': 'In-Play',
    'tabsNameToday': 'Today',
    'tabsNameTomorrow': 'Tomorrow',
    'tabsNameFuture': 'Future',
    'tabsNameNext': 'Next Races',
    'tabsNameResults': 'Results',
    'tabsNameCoupons': 'Coupons',
    'tabsNameMatches': 'Matches',
    'tabsNameEvents': 'Events',
    'tabsNameFights': 'Fights',
    'tabsNameMatchesGolf': '2/3 Balls',
    'tabsNameCompetitions': 'Competitions',
    'tabsNameOutrights': 'Outrights',
    'tabsNameScorecast': 'Scorecast',
    'tabsMarkets': 'Markets',
    'tabsNameMainMarkets': 'Main Markets',
    'tabsNameGoalMarkets': 'Goal Markets',
    'tabsNameScoreMarkets': 'Score Markets',
    'tabsNameHalfMarkets': 'Half Markets',
    'tabsNameCornerMarkets': 'Corner Markets',
    'tabsNameCardMarkets': 'Card Markets',
    'tabsNameOtherMarkets': 'Other Markets',
    'tabsNameAllMarkets': 'All Markets',
    'tabsNameStandings': 'Standings',
    'LastGoalScorecast': 'Last Scorer',
    'LastGoalscorerScorecast': 'Last Scorer',
    'FirstGoalScorecast': 'First Scorer',
    'FirstGoalscorerScorecast': 'First Scorer',
    'popularGoalscorerMarkets': 'Popular Goalscorer Markets',
    'otherGoalscorerMarkets': 'Other Goalscorer Markets',
    'firstSecondHalfResult': '1st Half / 2nd Half Result',
    'firstHalfResult': '1st Half',
    'secondHalfResult': '2nd Half',
    'minsA': '15 Mins',
    'minsB': '30 Mins',
    'minsC': '60 Mins',
    'minsD': '75 Mins',
    'overUnderTotalGoals': 'Over/Under Total Goals',
    'HalfTimeFullTime': 'Half Time/Full Time',
    'drawNoBet': 'Draw No Bet',
    'doubleChance': 'Double Chance',
    'visualisation': 'Match Stats',
    'Matches': 'Matches',
    'Outrights': 'Outrights',
    'Results': 'Results',

    'daySunday': 'Sunday',
    'dayMonday': 'Monday',
    'dayTuesday': 'Tuesday',
    'dayWednesday': 'Wednesday',
    'dayThursday': 'Thursday',
    'dayFriday': 'Friday',
    'daySaturday': 'Saturday',

    'monthJanuary': 'January',
    'monthFebruary': 'February',
    'monthMarch': 'March',
    'monthApril': 'April',
    'monthMay': 'May',
    'monthJune': 'June',
    'monthJuly': 'July',
    'monthAugust': 'August',
    'monthSeptember': 'September',
    'monthOctober': 'October',
    'monthNovember': 'November',
    'monthDecember': 'December',

    'monJanuary': 'Jan',
    'monFebruary': 'Feb',
    'monMarch': 'Mar',
    'monApril': 'Apr',
    'monMay': 'May',
    'monJune': 'Jun',
    'monJuly': 'Jul',
    'monAugust': 'Aug',
    'monSeptember': 'Sep',
    'monOctober': 'Oct',
    'monNovember': 'Nov',
    'monDecember': 'Dec',

    'addToBetslip': 'Add to Betslip',
    'myBets': 'My Bets',
    'oddsAPlaces': 'EW: {num}/{den} Odds - Places {arr}',
    'newOddsAPlaces': 'EW: {num}/{den} Odds - Places {arr}',
    'newOddsAPlacesExtended': 'EW: {num}/{den} Odds - Places {arr}',
    'oddsAPlacesLabel': 'Odds - Places',
    'class': 'Class {class}',
    'eachWayTermsLabel': 'EW: ',
    'PlaceLabel': 'Place',
    'SilkLabel': 'Silk',
    'TrapLabel': 'Trap',
    'RunnersLabel': 'Runners',
    'GreyhoundsLabel': 'Greyhounds',
    'PriceSPLabel': 'Price(SP)',
    'dividendStraight': 'Straight forecast:',
    'dividendTricast': 'Tricast:',
    'confirmClearOfBetSlip': 'Confirm clear betslip',

    'ssDown': 'There was a problem retrieving the information requested',
    'error': 'Error',
    'warning': 'Warning!',
    'serverError': 'Server is unavailable at the moment, please try again later.',

    'watch': 'Watch',
    'watchInsights': 'Watch & Insights',
    'Insights': 'Insights',
    'watchLive': 'Watch Live',
    'watchReplay': 'Watch Replay',
    'Replay': 'Replay',
    'watchStop': 'Stop',
    'liveSim': 'PRE-PARADE',
    'videoStream': 'VIDEO STREAM',
    'watchFreeInformation': 'Find out more about Watch Free here',
    'watchFreeInformationTitle': 'EVERY RACE, EVERY ANGLE, EVERY DAY...',
    'preRace': 'Pre-Race Sim',
    /* eslint-disable */
    'loginRequired':
        'In order to watch this stream, you must be logged in and have a positive balance or have placed a sportsbook bet in the last 24 hours.',
    'servicesCrashed': 'The Stream for this event is currently not available.',
    'eventNotStarted': 'This stream has not yet started. Please try again soon.',
    'eventFinished': 'This event is over.',
    'eventCompleted': 'This stream is over.',
    'onlyLoginRequired': 'In order to watch this stream, you must be logged in.',
    'onlyForMobile': 'This feature available only for mobile devices.',
    'underConstruction': 'This page is currently in preparation',
    'noMarketsFound': 'No markets found',
    'deniedByWatchRules': 'In order to view this event you need to place a bet greater than or equal to £1',
    'deniedByInactiveWatchRules': 'In order to watch the race you must have a funded account or have placed a bet in the last 24 hours',
    'geoBlocked':
        'You are blocked by geolocation. This live stream might not be supported in your current location. Please contact support team for further information.',
    'usageLimitsBreached': 'Your limit for streaming has been exceeded. Please try again later.',
    'fairUseBreach': 'Fair Use Breach.',
    'howToPlay': 'Football Jackpot Operation',

    'proceedLuckyDip': 'Proceed to replace your selections with Lucky Dip selections?',

    'home': 'Home',
    'draw': 'Draw',
    'away': 'Away',
    'noGoal': 'No Goal',
    'tennisSet': 'Set',

    'numSuffixTh': 'th',
    'numSuffixSt': 'st',
    'numSuffixNd': 'nd',
    'numSuffixRd': 'rd',

    'promotions': 'Promotions',
    'moreInformation': 'More information',
    'moreInfo': 'More info',
    'noPromotionsFound': 'No active Promotions at the moment',
    'termsAndConditionsLabel': 'Terms and Conditions',
    'cashout': 'cash out',
    'smallHome': 'H',
    'smallAway': 'A',
    'smallDraw': 'D',
    'summary': 'Summary',
    'showForm': 'Show Summary',
    'hideForm': 'Hide Summary',
    'noSummary': 'Currently there is no Summary available.',
    'noDetails': 'Currently there are no Details available.',

    'handicapResults': 'Handicap Results',
    'matchResult': '90 mins',
    'firstHalf': '1st Half',
    'secondHalf': '2nd Half',
    'bothHalves': 'Both Halves',
    'totalGoals': 'Total Goals',
    'total': 'Total',
    'over': 'Over',
    'under': 'Under',
    'showLess': 'Show Less',
    'overUnderGoals': 'Over/Under goals',
    'yes': 'Yes',
    'no': 'No',
    'yourEnhanceMarkets': 'Your Enhanced Markets',
    'privateMarktesTermsAndConditions': 'Private Markets Terms and Conditions',
    'currentMatches': 'Current Matches',
    'favouriteMatches': 'Favourite Matches',
    'addFavouriteMatch': 'Add Favourite Match',
    'noMarketsAvailable': 'No markets are currently available for this event',
    'noCashOutAvailable': 'Cash Out is not available for this event',
    'favourites': 'Favourites',

    'coralIntroducesNew': 'Coral introduces new',
    'featureAllowingYouTo': 'feature allowing you to',
    'easilyAccessAndFollowSeveral': 'easily access and follow several',
    'matchesOfYourChoice': 'matches of your choice',
    'pressingTheStarWillAddThis': 'Pressing the star will add this',
    'matchToYour': 'match to your',
    'hereYouCanQuicklyAndEasily': 'Here you can quickly and easily',
    'accessYourFavouritedMatches': 'access your favourited matches',
    'tryItNow': 'Try it now!',
    'closeTutorial': 'Close tutorial',
    'showMore': 'Show More',
    'seeMoreDates': 'See More Dates',
    'showLessSln': 'SHOW LESS SELECTIONS',
    'showMoreSln': 'SHOW ALL SELECTIONS',

    'byMeetingGH': 'BY MEETING',
    'byTimeGH': 'BY TIME',
    'noResultsAvalaible': 'No Results Available',

    'scorecast': {
        selectGoalscorer: 'Select Goalscorer',
        selectResult: 'Select Result',
    },

    'footballJackpotReceipt': 'Football Jackpot Bet Receipt',
    'jackpotLines': 'Lines',
    'footballJackpot': 'Football Jackpot ',
    'betReceiptNo': 'Bet Receipt No: ',
    'totalStake': 'Total Stake: ',
    'estReturns': 'Est. Returns: ',
    'betLines': 'Number of Lines: ',
    'game': 'Game',
    'jackpotSelection': 'Selection',
    'done': 'Done',

    'freeBetsAvalaible': 'Free Bets Available',
    'betRejectedError': 'Pool bet has been rejected by system.',
    'insuficientFoundsError': 'Bet is not placed due to insufficient funds. Please make a ',
    'depositSmall': 'deposit.',
    'goToEvent': 'Go to event',
    'liveCommentary': 'Live Commentary',
    'noThanks': 'No, thanks',
    'okThanks': 'Ok, Thanks',
    'deposit': 'deposit',
    'leagueTable': 'League Table',

    'fullScreenAvailable': 'Full Screen Available',

    /* Abbrivations for SLP aggregation */
    'handicap2way': 'Hcap 2-way',
    'hometeamtotalpoints': 'Home Total',
    'awayteamtotalpoints': 'Away Total',
    'halftotalpoints': 'Half Total',
    'quartertotalpoints': 'Qtr Total',
    'halfbetting': 'Half',
    'totalpointsoddeven': 'Total - odd/even',
    'nodrawhandicap1': 'No Draw Hcap 1',
    'nodrawhandicap2': 'No Draw Hcap 2',
    'nodrawhandicap3': 'No Draw Hcap 3',
    'totalmatchpoints': 'Total Points',
    'handicapbetting': 'Hcap',
    'winningmargin': 'Win Margin',
    'matchbettingwithovertime': 'Match Bet (OT)',
    'earlyPricesAvailable': 'Early Prices Available',
    'void': 'Void',
    'susp': 'SUSP',
};
/* eslint-enable */
